<template>
    <div class="container">
      <div id="page1-div" ref="document" class="container interline">
        <div
          class="col-12 container border page-container"
        >

            <div class="col-12 row border-dark row m-0 py-2">
            <div class="col-2 border text-center border-dark p-2">
                <img src="../Logo-GPI.png" class="rounded" width="50px" />
            </div>
            <div class="col-10 border border-dark text-center py-4 bg-gpi-azulito">
                <span class="ft13Black">
                    CARATULA
                <br />
                <br />
                </span>
            </div>
            </div>
            <!-- DATOS GENERALES -->
            <div class="col-12 row m-0 py-2">
                <div
                    class="col-12 border border-dark auto bg-dark p-2 text-center"
                >
                    <span class="ft13Black text-white">GPI AUTO COMERCIAL SAPI DE C.V.</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">TIPO DE FINANCIAMIENTO</span>
                </div>
                <div
                    class="col-6 border border-dark auto m-0"
                >
                    <span class="ft11Black">{{ data.type_quote }}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">CLIENTE:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.nombre_cliente }}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">OBLIGADO SOLIDARIO:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.nombre_obligado }}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">AVAL:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11"
                    >{{ data.nombre_aval }}</span
                    >
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">CIUDAD DE FINANCIAMIENTO:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">
                        {{ data.colonia_cliente}},
                        {{data.municipio_cliente }},
                        {{data.estado_cliente}}
                    </span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">MARCA, VERSION Y MODELO:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">
                        {{ data.marca_vehiculo}},
                        {{data.modelo_vehiculo }},
                        {{data.año_vehiculo}}
                    </span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">SUCURSAL:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.sucursal_asesor }}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">LOTE:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11"> {{data.lote}} </span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">PAGO A TERCERO:</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{data.pago_tercero}} </span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">PROMOTOR</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{data.nombre_asesor}}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">COMPAÑÍA ASEGURADORA</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.seguro_nombre }}</span>
                </div>
                <div
                    class="col-6 border border-dark m-0 m-0"
                >
                    <span class="ft11Black">CONDICIONES ESPECIALES</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11"></span>
                </div>
                <div
                    class="col-6 border border-dark m-0"
                >
                    <span class="ft11Black">EXPIDE ULTIMA FACTURA</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{data.emisor_factura}}</span>
                </div>

                <div class="col-6 border border-dark m-0">
                    <span class="ft11Black">NUMERO DE CARTERA</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.No_Operacion_Cliente }}</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11Black">NUMERO REFERENCIA</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11">{{ data.referencia_banco }}</span>
                </div>
                <div class="col-6 border border-dark m-0">
                    <span class="ft11Black">FACTURACION</span>
                </div>
                <div class="col-6 border border-dark row  p-0 m-0">
                    <div class="col-2 border border-dark text-center p-0 m-0">
                        <span class="ft11">SI</span>
                    </div>
                    <div class="col-2 border border-dark text-center p-0 m-0">
                        <span class="ft11">NO</span>
                    </div>
                    <div class="col-8 border border-dark text-center p-0 m-0 bg-gpi-naranga">
                        <span class="ft11 text-white">{{ data.correo }}</span>
                    </div>
                </div>
            </div>

            <!-- DATOS CALCULADOS -->
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft11">VALOR DECLARADO DEL AUTO</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft11">{{ getNumberLetter(data.precio_vehiculo )}}</span>
                </div>
                <div class="col-2">
                    <span class="ft11"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft11">MERCAMETRICA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft11"></span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-2 auto">
                    <span class="ft11"></span>
                </div>
                <div class="col-2 auto">
                    <span class="ft11"></span>
                </div>
                <div class="col-2 auto">
                    <span class="ft11"></span>
                </div>
                <div class="col-2">
                    <span class="ft11"></span>
                </div>
                <div class="col-4 border border-dark auto">
                    <span class="ft11">NOTA DIFERENCIA MAYOR AL 10%</span>
                </div>
            </div>

            <div v-if="data.type_quote =='PRENDARIO' || data.type_quote =='ESPECIAL'"  class="col-12 row m-0 ">
                <div class="col-2 border border-dark auto">
                    <span class="ft11">ENGANCHE</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft11"> {{ getNumberLetter(parseFloat((data.enganche/data.precio_vehiculo)*100).toFixed(2)) }}%</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft11">{{ getNumberLetter(data.enganche) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft11"></span>
                </div>
                <div class="col-4 border border-dark auto">
                    <span class="ft11"></span>
                </div>
            </div>

            <div  class="col-12 row m-0 ">
                <div class="col-2 border border-dark auto p-0 pl-2 ">
                    <span v-if="data.type_quote !='EXTIÉNDETE'" class="ft9">COMISION APERTURA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span v-if="data.type_quote !='EXTIÉNDETE'"  class="ft9">{{ (data.comisionApertura)}}% SOBRE VALOR</span>
                </div>
                <div v-if="data.type_quote =='PRENDARIO'" class="col-2 border border-dark auto">
                    <span class="ft11">{{ getNumberLetter(this.data.monto_a_finaciar_sin_seguro * (data.comisionApertura/100)) }}</span>
                </div>
                <div v-if="data.type_quote !='PRENDARIO'" class="col-2 border border-dark auto">
                    <span v-if="data.type_quote !='EXTIÉNDETE'"  class="ft11">{{ getNumberLetter(this.data.precio_vehiculo * (data.comisionApertura/100)) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft11">&nbsp;</span>
                </div>
                <div class="col-4 auto">
                    <span class="ft11">&nbsp;</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">SEGURO DE CONTADO</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{  getNumberLetter(data.seguro_vehiculo !="FINANCIADO"? data.precio_seguro: 0)  }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">TASA CON IVA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.tasa)}}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span v-if="data.type_quote =='ARRENDAMIENTO'" class="ft10">GASTOS ADMINISTRATIVO (ENGANCHE)</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">
                        <span v-if="data.type_quote =='ARRENDAMIENTO'" class="ft11">{{ getNumberLetter(data.enganche) }}</span>
                    </span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">GPS CON IVA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{(data.gps_sin_iva*1.16).toFixed(0)}}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span v-if="data.type_quote =='ARRENDAMIENTO'" class="ft10">RENTA ANTICIPADA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span v-if="data.type_quote =='ARRENDAMIENTO'" class="ft10">{{ getNumberLetter(parseFloat(data.mensualidad).toFixed(2)) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">SDD CON IVA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{(data.sdd_sin_iva*1.16).toFixed(0)}}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-azulito text-center">
                    <span class="ft10Black">DESEMBOLSO INCICIAL</span>
                </div>
                <div v-if="data.type_quote !='ARRENDAMIENTO' && data.type_quote !='EXTIÉNDETE'"
                     class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft11">
                        {{
                            getNumberLetter(
                                parseFloat(data.enganche) +
                                parseFloat(data.seguro_vehiculo !="FINANCIADO"? data.precio_seguro: 0) +
                                parseFloat(data.monto_a_finaciar_sin_seguro * (data.comisionApertura/100))
                            )
                        }}
                    </span>
                </div>
                <div v-if="data.type_quote =='EXTIÉNDETE'"
                     class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft11">
                        {{
                            getNumberLetter(
                                parseFloat(data.seguro_vehiculo =="CONTADO"? 0: data.precio_seguro))
                        }}
                    </span>
                </div>
                <div v-if="data.type_quote =='ARRENDAMIENTO'" class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft11">
                      {{
                        getNumberLetter(
                            parseFloat(data.enganche) + parseFloat(data.mensualidad) +
                            parseFloat(data.seguro_vehiculo !="FINANCIADO"? data.precio_seguro: 0) +
                            parseFloat(data.precio_vehiculo * (data.comisionApertura/100))
                        )
                      }}
                    </span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">PLAZO</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ data.plazo }}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">PAGO DE LA UNIDAD (VALOR DECL. – ENGANCHE)</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.precio_vehiculo - data.enganche) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-4 auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">SEGURO FINANCIADO (CUBRE SOLO UN AÑO DE SERVICIO)</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.seguro_vehiculo =="FINANCIADO"? data.precio_seguro: 0)  }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-4 auto border border-dark bg-gpi-azulito">
                    <span class="ft10Black">CUENTA POR COBRAR</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-azulito text-center">
                    <span class="ft10Black">MONTO A FINANCIAR</span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">{{ getNumberLetter(data.monto_a_finaciar)}}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">RENTAS/CAPITAL</span>
                </div>
                <div v-if="data.type_quote =='PRENDARIO'" class="col-2 border border-dark auto ">
                    <span class="ft10">{{ getNumberLetter(data.monto_a_finaciar) }}</span>
                </div>
                <div  v-if="data.type_quote !='PRENDARIO'" class="col-2 border border-dark auto ">
                    <span class="ft10">{{ getNumberLetter( (data.mensualidad * data.plazo)) }}</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-6 auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">INTERESES</span>
                </div>
                <div v-if="data.type_quote =='PRENDARIO'" class="col-2 border border-dark auto">
                    <span class="ft10">{{  getNumberLetter(((data.tasa*(data.plazo/100))*data.monto_a_finaciar ).toFixed(2)) }}</span>
                </div>
                <div v-if="data.type_quote =='ARRENDAMIENTO' || data.type_quote =='EXTIÉNDETE'
                     || data.type_quote =='RENUEVATE'"
                    class="col-2 border border-dark auto">
                    <span class="ft10">0.0</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span v-if="data.type_quote =='ARRENDAMIENTO'" class="ft10">RESIDUAL</span>
                </div>
                <div v-if="data.type_quote !='ARRENDAMIENTO'"  class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div v-if="data.type_quote =='ARRENDAMIENTO'" class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.residual) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">GPS</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter((data.gps_sin_iva*1.16)* data.plazo )}}</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">MENSUALIDAD / RENTA</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.mensualidad) }}</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">SDD</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter((data.sdd_sin_iva*1.16)*data.plazo) }}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">&nbsp;</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">&nbsp;</span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-gpi-azulito">
                    <span class="ft10">RESIDUAL</span>
                </div>
                <div v-if="data.type_quote =='PRENDARIO'"  class="col-2 border border-dark auto">
                    <span class="ft10">-</span>
                </div>
                <div v-if="data.type_quote !='PRENDARIO'" class="col-2 border border-dark auto">
                    <span class="ft10">{{ getNumberLetter(data.residual) }}</span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-6  auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto bg-warning">
                    <span class="ft10">CUENTAxCOBRAR</span>
                </div>
                <div v-if="data.type_quote !='ARRENDAMIENTO'" class="col-2 border border-dark auto">
                    <span class="ft10">{{
                        getNumberLetter((
                            (data.monto_a_finaciar) +
                            ((data.tasa*(data.plazo/100))*data.monto_a_finaciar )+
                            ((data.sdd_sin_iva*1.16)*data.plazo)+
                            ((data.gps_sin_iva*1.16)*data.plazo)
                        ).toFixed())
                        }}</span>
                </div>
                <div v-if="data.type_quote =='ARRENDAMIENTO'" class="col-2 border border-dark auto">
                    <span class="ft10">{{
                        getNumberLetter((
                            (data.mensualidad * (data.plazo - data.rentas_adelantadas)) +
                            Number(data.residual)
                        ).toFixed())
                        }}</span>
                </div>
            </div>
            <br>

            <!-- CONCEPTOS Y MONTOS PAGO  -->
            <div class="col-12 row m-0 ">
                <div class="col-12 border border-dark auto bg-dark py-1 text-center">
                    <span class="ft13Black text-white ">Conceptos y Montos Pago Lote/Agencia</span>
                </div>
            </div>

            <div class="col-12 row m-0">
                <div class="col-4 border border-dark auto">
                    <span class="ft10">&nbsp; </span>
                </div>
                <div class="col-8  bg-gpi-naranga">
                    <span class="ft10"></span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">Pago Lote o Agencia sin comisión por apertura del 3%</span>
                </div>
                <div v-if="data.type_quote =='PRENDARIO'" class="col-2 border border-dark auto">
                    <span class="ft10">
                        {{
                            getNumberLetter(data.monto_a_finaciar_sin_seguro - ((data.monto_a_finaciar_sin_seguro * (data.comisionApertura/100))).toFixed(2) )
                        }}
                    </span>
                </div>
                <div v-if="data.type_quote =='ARRENDAMIENTO'" class="col-2 border border-dark auto">
                    <span class="ft10">
                        {{
                            getNumberLetter( Number(data.precio_vehiculo).toFixed(2) )
                        }}
                    </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>

            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span v-if="data.type_quote !='EXTIÉNDETE' && data.type_quote !='RENUEVATE'"  class="ft10 text-white">Pago comisión lote o Agencia {{this.data.comisionLote}}%</span>
                </div>
                <div class="col-1 border border-dark auto">
                    <span v-if="data.type_quote !='EXTIÉNDETE' && data.type_quote !='RENUEVATE'" class="ft10">{{getNumberLetter(this.data.comisionLote)}}%</span>
                </div>
                <div class="col-3 border border-dark auto">
                    <span v-if="data.type_quote !='EXTIÉNDETE' && data.type_quote !='RENUEVATE'" class="ft10">{{ getNumberLetter(data.monto_a_finaciar_sin_seguro * (this.data.comisionLote/100))}}</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10">&nbsp;</span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">&nbsp; </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">&nbsp; </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">&nbsp; </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">&nbsp; </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">&nbsp; </span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
                <div class="col-2 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <br>
            <!-- CONCEPTOS Y MONTOS PAGO  -->
            <div class="col-12 row m-0 ">
                <div class="col-12 border border-dark auto bg-dark py-1 text-center">
                    <span class="ft13Black text-white ">Autorización</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto ">
                    <span class="ft10 text-white">&nbsp;</span>
                </div>
                <div class="col-4 border border-dark auto bg-gpi-naranga text-center">
                    <span class="ft10 text-white">Autoriza</span>
                </div>
                <div class="col-4 border border-dark auto bg-gpi-naranga text-center">
                    <span class="ft10 text-white">Firma de Autorización</span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">Crédito</span>
                </div>
                <div class="col-4 border border-dark auto text-center">
                    <span class="ft10">JUAN MANUEL AGUIRRE</span>
                </div>
                <div class="col-4 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>
            <div class="col-12 row m-0 ">
                <div class="col-4 border border-dark auto bg-gpi-naranga">
                    <span class="ft10 text-white">Gerencia de Operaciones</span>
                </div>
                <div class="col-4 border border-dark auto text-center">
                    <span class="ft10">JESUS FERNANDEZ MORAN</span>
                </div>
                <div class="col-4 border border-dark auto">
                    <span class="ft10"></span>
                </div>
            </div>

        </div>
      </div>
    </div>
  </template>

  <script>
  import environment from "../../../environments/Environment";
  export default {
    name: "Caratula_Credito",
    data() {
      return {
      };
    },
    validations() {
      return {};
    },
    props: {
      data: {
        type: Object
      }
    },
    methods: {
    getNumberLetter(value){
        let val = (value/1).toFixed(2).replace(',', '.');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
      preloader() {
        $(".preloader").fadeIn();
        $(".preloader")
          .delay(10)
          .fadeIn("slow");
      },
      preloaderHiden() {
        $(".preloader").fadeOut();
        $(".preloader")
          .delay(10)
          .fadeOut("slow");
      }
    },
    created() {
      window.scrollTo(0, 0);
    }
  };
  </script>
  <style type="text/scss">
  @import "../style.scss";
  </style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/Caratula_credito.vue